import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Color } from '../../../api/models/color.model';

export const cctColorAdapter: EntityAdapter<Color> = createEntityAdapter<Color>({
    selectId: (color: Color) => color.Id,
});

export interface CCTColorState extends EntityState<Color> {
    total: number;
    loaded: boolean;
    ids: number[];
    entities:any;
}
